// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2NFJl","text":"SelectPayment_text__22ecZ","title":"SelectPayment_title__2jJRH","btn":"SelectPayment_btn__2YAbN"};